import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { Toaster } from "./components/ui/sonner";
import InstallPrompt from "./components/InstallPrompt";
import { AppLayout } from "./components/AppLayout";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import PayslipsPage from "./pages/PayslipsPage";
import VacationPage from "./pages/VacationPage";
import PersonalDataPage from "./pages/PersonalDataPage";
import DocumentsPage from "./pages/DocumentsPage";
import AdminPage from "./pages/AdminPage";
import "./App.css";

function ProtectedRoute({ children, adminOnly = false }) {
  const { user, loading, mustChangePassword } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/" replace />;
  if (mustChangePassword) return <Navigate to="/" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  return children;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route
            element={
              <ProtectedRoute>
                <AppLayout />
              </ProtectedRoute>
            }
          >
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/payslips" element={<PayslipsPage />} />
            <Route path="/vacation" element={<VacationPage />} />
            <Route path="/documents" element={<DocumentsPage />} />
            <Route path="/personal-data" element={<PersonalDataPage />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute adminOnly>
                  <AdminPage />
                </ProtectedRoute>
              }
            />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster richColors position="top-right" />
        <InstallPrompt />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
